module.exports = __webpack_public_path__ + "img/P5181348.8a23ffb5.jpg";